export default __webpack_public_path__ + "static/port-5-99e8a5f2a6939f0f170285d7e992aa59.jpeg";